import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

const Teams = ({
    row,
    col,
    selected,
    onCellChange,
    keyValue
}) => {
    const { teams, team } = row;
    const { field } = col;
    const _teams = Object.keys(teams);

    if (_teams.length > 0 && selected) {
        return (
            <Select id={`${keyValue}-team-selector`} value={team} onChange={e => onCellChange(e, field)} displayEmpty >
                <MenuItem value='' disabled key={`${keyValue}-team-default`}>Select</MenuItem>
                {
                    _teams.map(_team => (
                        <MenuItem value={_team} key={`${keyValue}-team-${_team}`}>{_team}</MenuItem>
                    ))
                }
            </Select>
        );
    }
    if (team && !selected) {
        return team;
    }
    return null;
};

Teams.propTypes = {
    row: PropTypes.object.isRequired,
    col: PropTypes.object.isRequired,
    selected: PropTypes.bool
};

export default Teams;